<template>
	<div>
		<!-- <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>弹出广告</div> -->
		<div class="title">
			<div class="left">
				<el-select v-model="filter.state" style="width: 150px;margin-right: 20px;margin-left: 20px;"
					size="small">
					<el-option v-for="item in activeStateList" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" v-model="filter.name" clearable placeholder="请输入弹窗广告名称"
					style="width: 200px;margin-right: 20px;" size="small"></el-input>
				<el-button type="primary" @click="getlist()" size="small">筛选</el-button>
			</div>
			<div class="right">
				<router-link to="/newAd">
					<el-button type="primary" size="small">新建弹出广告</el-button>
				</router-link>
			</div>
		</div>
		<div class="tabelContent" style="margin-top: 20px;">
			<el-table :data="adDataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
				style="width: 99%">
				<el-table-column prop="name" align="center" label="弹窗广告名称"></el-table-column>
				<el-table-column label="投放时间段" align="center" width="200">
					<template slot-scope="scope">
						<p>起：{{scope.row.startTime}}</p>
						<p>止：{{scope.row.endTime}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="label" align="center" label="投放人群"></el-table-column>
				<el-table-column prop="style" align="center" label="广告样式">
					<template slot-scope="scope">
						<el-image :src="scope.row.style"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="当前状态" align="center">
					<template slot-scope="scope">
						<span>
							{{scope.row.status==0?'未开始':''}}
							{{scope.row.status==1?'进行中':''}}
							{{scope.row.status==2?'已结束':''}}
							{{scope.row.status==3?'已失效':''}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="popPosition" label="投放位置" align="center">
					<template slot-scope="scope">
						<span>
							{{scope.row.popPosition==0?'首页':''}}
							{{scope.row.popPosition==1?'订单页':''}}
							{{scope.row.popPosition==2?'我的':''}}
							{{scope.row.popPosition==3?'会员页':''}}
							{{scope.row.popPosition==4?'活动页':''}}
						</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="couponId" align="center" label="优惠券">
				</el-table-column> -->
				<!-- <el-table-column align="center" label="打开次数">
					<template slot-scope="scope">
						{{scope.row.open?"open":"未打开"}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="打开率">
					<template slot-scope="scope">
						{{scope.row.openRate}}%
					</template>
				</el-table-column> -->
				<el-table-column label="操作" align="center" width="150">
					<template slot-scope="scope">
						<div v-if="scope.row.status!=3">
							<el-button type="text" size="small" @click="editAd(scope.row.id)"
								style="margin-right: 20px;">编辑</el-button>
							<el-popconfirm title="确定失效吗？" @onConfirm="invalid(scope.row.id)">
								<el-button type="text" size="mini" slot="reference">失效</el-button>
							</el-popconfirm>
						</div>
						<div v-if="scope.row.status==3">
							<el-button type="text" size="small" style="margin-right: 20px;">查看</el-button>
							<el-button type="text" size="mini" @click="deleteadver(scope.row.id)" slot="reference"><span
									style="color: red;">删除</span></el-button>
						</div>
						</el-popover>
					</template>
				</el-table-column>
			</el-table>
			<div class="turn">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.pageNum" :page-sizes="[10, 20, 50]" :page-size="filter.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				total: 0,
				filter: {
					id: undefined,
					pageNum: 1, //页码
					pageSize: 5, // 条数
					status: "", // 状态 0未开始-1进行中-2已结束-3已失效
					name: "" //广告名称
				},
				activeStateList: [{
					value: "",
					label: "全部状态"
				}, {
					value: 0,
					label: "未开始"
				}, {
					value: 1,
					label: "进行中"
				}, {
					value: 2,
					label: "已结束"
				}, {
					value: 3,
					label: "已失效"
				}],
				adDataList: [],
				deleteAd: false
			}
		},
		watch: {
			filter: {
				handler(newValue, oldValue) {
					alert(1)
				},
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			//删除广告
			deleteadver(id) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("dvertisement/delDAdvertisement", JSON.stringify({
						id: id
					})).then(function(res) {
						if (res.body.code == 200) {
							this.$message.success("删除成功")
						}
					})
				});
			},
			// 失效
			invalid(id) {
				this.$http.post("dvertisement/invalidDAdvertisement", JSON.stringify({
					id: id
				})).then(function(res) {
					if (res.body.code == 200) {
						this.$message.success("失效成功")
						this.getlist()
					}
				})
			},
			getlist() {
				this.$http.post("dvertisement/findDAdvertisement", JSON.stringify(this.filter)).then(function(res) {
					if (res.body.code == 200) {
						this.adDataList = res.body.data
						this.total = res.body.total
					}
				})
			},
			editAd(id) {
				this.$router.push({
					path: 'newAd',
					query: {
						id: id
					}
				})
			},
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getlist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getlist()
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.title {
		width: 100%;

		.left {
			margin-left: -20px;
			float: left;
		}

		.right {
			position: absolute;
			right: 40px;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	.turn {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>